import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  findTicketLocation,
  deleteMovedTicket,
  getTicketsToBeMoved,
  fetchTicketFromCheckoutTbl,
} from '../helpers/databaseAPI';
import styles from '../css/mainPage.module.css';
import { useEffect, useState } from 'react';
import { checkDataType } from 'ajv/dist/compile/validate/dataType';

function ModifyTicketLoc({ ticketsToMove, setTicketsToMove, loginURL, changedTkt, refresh }) {
  const navigate = useNavigate();
  const [exitingTkt, setExitingTkt] = useState([]);
  const [pop, setPop] = useState({
    open: false,
    top: 0,
    left: 0,
  });

  useEffect(() => {
    async function blockedTkts() {
      await getTicketsToBeMoved(loginURL);
    }
    blockedTkts();
    if (changedTkt) {
      console.log('Occupied spaces in useEffect', changedTkt);
      const updatedTicket = changedTkt;
      setTicketsToMove((prev) => [...prev.filter((t) => t.Ticket !== updatedTicket), ...ticketsToMove]);
      console.log('Occupied spaces in useEffect2', checkDataType, updatedTicket, ticketsToMove);
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setPop((prev) => ({ ...prev, open: false })); //Preserve left and top
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div>
      <h1 style={{ textAlign: 'center', color: 'black ' }}>Modify Car Location</h1>
      <div>
        <table className={styles.modifySpotTable}>
          <thead>
            <tr>
              <th>Ticket</th>
              <th>Locator</th>
              <th>Section</th>
              <th>Lane/Space</th>
              <th>Exiting</th>
              <th>Employee</th>
            </tr>
          </thead>
          <tbody>
            {ticketsToMove.map((item, id) => (
              <tr key={id}>
                <td>
                  <a
                    href="##"
                    onClick={async (e) => {
                      const targetTkt = await findTicketLocation(loginURL, item.Ticket);
                      console.log(targetTkt, item.Ticket, 'Target Ticket');
                      if (targetTkt !== null) {
                        navigate('/ticketEntry', { state: { targetTicket: item.Ticket, deleteTicket: true } });
                      } else {
                        alert('Ticket ' + item.Ticket + ' does not exit');
                        await deleteMovedTicket(loginURL, item.Ticket);
                        setTicketsToMove((prev) => [...prev.filter((t) => t.Ticket !== item.Ticket)]);
                        // localStorage.clear();
                        // localStorage.removeItem(item.Ticket);
                        // localStorage.setItem('ticketsToRemove', JSON.stringify(ticketsToMove));
                        // context.setTicketsToBeMoved(ticketsToMove);
                        console.log(ticketsToMove, 'Ticket to move after button is clicked');
                      }
                    }}
                  >
                    {item.Ticket}
                  </a>
                </td>
                <td>
                  <a
                    href="##"
                    onClick={async (e) => {
                      const targetLocator = await findTicketLocation(loginURL, item.Locator);
                      console.log(targetLocator, item.Locator, 'Target Locator');
                      if (targetLocator !== null) {
                        navigate('/ticketEntry', { state: { targetLocator: item.Locator, deleteTicket: true } });
                      } else {
                        alert('Ticket ' + item.Locator + ' does not exit');
                        await deleteMovedTicket(loginURL, item.Ticket);
                        setTicketsToMove((prev) => [...prev.filter((t) => t.Ticket !== item.Ticket)]);
                        console.log(ticketsToMove, 'Ticket to move after button is clicked');
                      }
                    }}
                  >
                    {item.Locator}
                  </a>
                </td>
                <td>{item.SectionName}</td>
                <td>
                  {item.LaneNum} / {item.SpaceNum}
                </td>
                <td>
                  <a
                    href="##"
                    popoverTarget="popover-target"
                    onClick={async (e) => {
                      e.preventDefault();

                      const rect = e.currentTarget.getBoundingClientRect();

                      const clickedTkt = await fetchTicketFromCheckoutTbl(loginURL, item.TargetTicket);
                      setExitingTkt(clickedTkt);
                      console.log(exitingTkt, clickedTkt, 'Exiting and clicked ticket');

                      !pop.open && clickedTkt[0].Ticket > 0
                        ? setPop({
                            open: true,
                            top: rect.bottom + window.scrollY,
                            left: rect.left + window.scrollX,
                          })
                        : setPop({ open: false });
                    }}
                  >
                    {item.TargetTicket}
                  </a>
                </td>
                <td>
                  {/* {(() => {
                    const parts = item.FullName.split(' ');
                    return `${parts[0]} ${parts[1].charAt(0)}`;
                  })()} */}
                  {!item.FullName
                    ? ''
                    : `${item?.FullName.split(' ')[0]} ${item.FullName.split(' ')[1].charAt(0)}`}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {pop.open && (
          <div
            style={{
              position: 'fixed',
              width: '175px',
              fontSize: '14px',
              top: pop.top,
              left: pop.left,
              backgroundColor: 'black',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '10px',
              borderRadius: '20px',
              zIndex: 1000,
            }}
            popover="auto"
            id="popover-target"
          >
            {exitingTkt.map((tkt) => {
              return (
                <div>
                  <div style={{ paddingBottom: '5px' }}>Exiting Ticket: {tkt.Ticket}</div>
                  <div style={{ paddingBottom: '5px' }}>Section: {tkt.SectionName}</div>
                  <div style={{ paddingBottom: '5px' }}>Lane: {tkt.LaneNum}</div>
                  <div style={{ paddingBottom: '5px' }}>Space: {tkt.SpaceNum}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default ModifyTicketLoc;
